export default {
  props:[
    'dashdata',
  ],
  
  methods:{
    getKpiByString: function (code) {
      if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0)
        return _.find(this.dashdata.KPI, (x) => x.KpiCode === code)
    },

    getKpiGroupByString: function (code) {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return _.find(this.dashdata.OverallByWave, (x) => x.KpiCode === code);
    },

    getQuestionByString: function(code) {
        if (this.dashdata && this.dashdata.Question && _.size(this.dashdata.Question) > 0)
          return _.find(this.dashdata.Question, (x) => x.KpiCode === code)
    },

    getOverallItem: function() {
        if (this.dashdata && this.dashdata.Overall && _.size(this.dashdata.Overall) > 0)
          return this.dashdata.Overall[0]
        return undefined
    },
    
    getKpiName: function(kpiCode) {
        let item = this.getKpiByString(kpiCode);
        if (item && item.KpiNameShort) {
          return item.KpiNameShort;
        }
        if (item && item.KpiName) {
          return item.KpiName;
        }
        return null;
    }
  },

  computed: {
    getOverallByWave: function() {
      if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
        return this.dashdata.OverallByWave[0]
      return undefined
    }
  }
}  